import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Card, Badge } from "./ui";
import { Plus, Pencil, Trash2, X } from "lucide-react";
import { toast } from "sonner";

const blank = {
  name: "", address: "", postal_code: "", city: "", province: "", website: "",
  phone: "", opening_hours: "", products: [], latitude: null, longitude: null,
  is_featured: false, is_active: true,
};

export default function AdminOutlets() {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/outlets").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...editing, products: typeof editing.products === "string" ? editing.products.split(",").map((s) => s.trim()).filter(Boolean) : editing.products };
      if (editing.id) await api.put(`/admin/outlets/${editing.id}`, payload);
      else await api.post("/admin/outlets", payload);
      toast.success("Opgeslagen"); setEditing(null); load();
    } catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { if (!window.confirm("Verkooppunt verwijderen?")) return; try { await api.delete(`/admin/outlets/${id}`); toast.success("Verwijderd"); load(); } catch (e) { toast.error(apiErr(e)); } };

  const inp = "w-full rounded-xl border border-white/10 bg-sfc-night px-3 py-2 text-sm text-white focus:border-sfc-orange focus:outline-none";
  const F = (k, label) => <label className="block"><span className="mb-1 block text-xs text-white/50">{label}</span><input className={inp} value={editing[k] ?? ""} onChange={(e) => setEditing({ ...editing, [k]: e.target.value })} /></label>;

  return (
    <div>
      <PageHeader title="Verkooppunten" subtitle="Beheer waar Soul Food City verkrijgbaar is">
        <button data-testid="add-outlet-btn" onClick={() => setEditing({ ...blank })} className="flex items-center gap-2 rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-5 py-2.5 text-sm font-semibold text-white"><Plus size={16} /> Nieuw verkooppunt</button>
      </PageHeader>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {rows.map((o) => (
          <Card key={o.id} className="p-5" data-testid={`admin-outlet-${o.id}`}>
            <div className="flex items-center justify-between"><h3 className="font-display text-lg text-white">{o.name}</h3><Badge status={o.is_active ? "approved" : "archived"} /></div>
            <p className="mt-1 text-sm text-white/60">{o.address}, {o.postal_code} {o.city}</p>
            <p className="text-xs text-white/40">{o.province}</p>
            <div className="mt-4 flex gap-2">
              <button onClick={() => setEditing({ ...o, products: (o.products || []).join(", ") })} className="flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-xs text-white/80 hover:bg-white/10"><Pencil size={13} /> Bewerken</button>
              <button onClick={() => del(o.id)} className="flex items-center gap-1.5 rounded-full border border-red-500/20 px-3 py-1.5 text-xs text-red-300 hover:bg-red-500/10"><Trash2 size={13} /></button>
            </div>
          </Card>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={() => setEditing(null)}>
          <div className="admin-scroll max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-3xl border border-white/10 bg-[#0e0722] p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between"><h2 className="font-display text-xl text-white">{editing.id ? "Bewerken" : "Nieuw verkooppunt"}</h2><button onClick={() => setEditing(null)}><X className="text-white/60" /></button></div>
            <div className="mt-5 grid gap-4 sm:grid-cols-2">
              {F("name", "Naam")}{F("phone", "Telefoon")}
              {F("address", "Adres")}{F("postal_code", "Postcode")}
              {F("city", "Plaats")}{F("province", "Provincie")}
              {F("website", "Website")}{F("opening_hours", "Openingstijden")}
              {F("latitude", "Latitude")}{F("longitude", "Longitude")}
              <label className="block sm:col-span-2"><span className="mb-1 block text-xs text-white/50">Producten (komma-gescheiden)</span><input className={inp} value={editing.products} onChange={(e) => setEditing({ ...editing, products: e.target.value })} /></label>
              <label className="flex items-center gap-2 text-sm text-white/70"><input type="checkbox" checked={editing.is_featured} onChange={(e) => setEditing({ ...editing, is_featured: e.target.checked })} className="h-4 w-4 accent-sfc-orange" /> Uitgelicht</label>
              <label className="flex items-center gap-2 text-sm text-white/70"><input type="checkbox" checked={editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} className="h-4 w-4 accent-sfc-orange" /> Actief</label>
            </div>
            <button data-testid="save-outlet-btn" onClick={save} className="mt-6 w-full rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-6 py-3 text-sm font-semibold text-white">Opslaan</button>
          </div>
        </div>
      )}
    </div>
  );
}
